import { navigate } from 'gatsby';
import React, { forwardRef, useImperativeHandle } from 'react';

import { getCustomer, logout } from '../../services/shopify';

const Orders = ({ children, location }, ref) => {
  useImperativeHandle(ref, () => ({
    getCustomer() {
      return getCustomer().then(({ customer }) => {
        if (customer) {
          customer.orders = customer.orders.edges.map(({ node }) => {
            node.totalPriceV2.amountStr = `$${parseFloat(
              node.totalPriceV2.amount,
              10
            ).toFixed(2)}`;
            return { ...node };
          });
          return customer;
        } else {
          logout(() => navigate(`/account/login`));
        }
      });
    },
  }));

  return <>{children}</>;
};

export default forwardRef(Orders);
